<template>
<div>

	<collapsible-panel :external-toggle="panelVisible" v-on:panelRetract="panelVisible = false">
		<template slot="panel">
			<h4>Filtering</h4>

			<field class="mr-2"
				label="Category"
				col-class="stacked"
				:params="{type:'select',options:categoryOptions}"
				v-model="selectedCategory"
				v-on:change="catChange">

				<span v-if="selectedCategory > 0">Now pick a template to filter the list</span>
			</field>

			<field v-if="selectedCategory > 0"
				label="Template"
				col-class="stacked"
				:params="{type:'select',options:templateOptions}"
				v-model="selectedTemplate"
				v-on:change="filterControlChange">
			</field>

			<field label="Active Only"
				col-class="col-auto"
				:params="{type:'boolean'}"
				v-model="activeOnly"
				v-on:change="filterControlChange">
			</field>

			<form-group label="Created At" col-class="stacked">

				<div class="d-flex">
					<field :params="{type:'date', placeholder: 'From'}" v-model="completedDateFrom" v-on:change="completedDateFromChange"></field>
					<field :params="{type:'date', placeholder: 'To'}" v-model="completedDateTo" v-on:change="completedDateToChange"></field>
				</div>

			</form-group>

			<form-group label="Expiry Date" col-class="stacked">

				<div class="d-flex">
					<field :params="{type:'date', placeholder: 'From'}" v-model="expiryDateFrom" v-on:change="expiryDateFromChange"></field>
					<field :params="{type:'date', placeholder: 'To'}" v-model="expiryDateTo" v-on:change="expiryDateToChange"></field>
				</div>

			</form-group>


		</template>
		<template slot="main">

			<div class="main-body">

				<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

				<div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
					<h2>
						<template v-if="title">{{title}}</template>
						<template v-else>Company Forms</template>
						
						<div>
							<small>{{subTitle}}</small>
						</div>
						
					</h2>
				</div>

				<div class="d-flex justify-content-between">
					<div>
						<button v-if="!noFilterPanel" class="btn btn-light mr-2" v-on:click="openFilterPanel" :disabled="panelVisible">
							<i class="fa fa-filter"></i>
							Filter
						</button>
					</div>
					<div v-if="viewMode == 'forms'" class="d-flex flex-row align-items-center flex-wrap mb-2">

						<div class="mr-2">
							<button class="btn-light btn" v-on:click="setViewMode('sharedForms')">View Previously Shared Form Groups...</button>
						</div>

						<button v-if="employeeId && $store.userDetails && employeeId == $store.userDetails.id" class="btn btn-primary mr-3" v-on:click="doCompanyForm">
							<i class="fa fa-clipboard-check mr-1"></i>
							Do Company Form
						</button>

						<button class="btn btn-light" :disabled="selectedRecords.length == 0" v-on:click="openShareModal">
							<i class="fa fa-paper-plane mr-1"></i>
							<span v-if="selectedRecords.length > 1">Send Multiple Forms...</span>
							<span v-else>Send Form...</span>
						</button>

					</div>
					<div v-else>
						<i class="fa fa-times icon-button" v-on:click="setViewMode('forms')"></i>
					</div>
					
				</div>

				<template v-if="viewMode == 'forms'">
					<table-list
						record-name="Form"
						:fields="fields"
						:records="mutatedForms"
						:hide-record-count="true"
						:sortable="true"
						has-edit="/form/view/"
						:edit-new-tab="true"
						edit-button-text="View"
						edit-button-icon="fa-eye"
						id-field="slug"
						:collapse-buttons="true"
						:mobile-breakpoint="500"
						:records-selectable="true"
						:has-delete="hasModulePermWrite('Company Forms')"
						:other-buttons="[
							{
								click: 'sendForm',
								text: 'Send Form',
								class: 'btn-light',
								icon: 'fa-paper-plane'
							},
							{
								click: 'openForm',
								condition: ['isActive',true],
								text: 'Add Participant',
								class: 'btn-light',
								icon: 'fa-user'
							},
							{
								click: 'editForm',
								condition: ['isActive',true],
								text: 'Edit Form',
								class: 'btn-light',
								icon: 'fa-pen'
							},
							{

								click: 'deactivateForm',
								condition: ['isActive',true],
								text: 'Deactivate Form',
								class: 'btn-outline-danger',
								icon: 'fa-times'
							}
						]"
						v-on:selectedRecordsChange="selectedRecordsChange"
						v-on:deactivateForm="deactivateForm"
						v-on:openForm="openForm"
						v-on:editForm="editForm"
						v-on:sendForm="sendForm"
						v-on:delete="deleteForm">

					</table-list>

					<div class="text-center" v-if="mutatedForms.length > 0 && numPages > page">
						<button class="btn btn-light" type="button" v-on:click="loadMore">
							Load More
						</button>
					</div>

					<!--
					<pagination
						:current-page="page"
						:pages="numPages"
						v-on:pageChange="pageChange">
					</pagination>
					-->
				</template>
				<template v-else>
					<table-list record-name="Shared Form Group"
						:records="mutatedShareGroups"
						:fields="[
							{label: 'Description',key: 'description'},
							{label: 'Shared By',key: 'sharedBy'},
							{label: 'Number of Forms',key: 'numForms',align:'center'},
						]"
						:has-delete="true"
						delete-endpoint="FormShareGroup/delete"
						:other-buttons="sharedGroupOtherButtons"
						v-on:modelChange="fetchShareGroups"
						v-on:goToPortal="goToPortal"
						v-on:copyLinkToClipboard="copyLinkToClipboard">
					</table-list>
				</template>

			</div>

		</template>
	</collapsible-panel>

	<modal-dialog :modal-visible="deactivateFormModal.visible"
		title="Deactivate Form"
		confirm-button-text="Yes, Deactivate"
		button-class="btn-outline-danger"
		v-on:closeModal="deactivateFormModal.visible = false"
		v-on:confirm="confirmDeactivateForm">

		Are you sure you want to deactivate this form? It will become readonly once you do so.

	</modal-dialog>

	<share-group-modal
		:visible="isGroupShareModalVisible"
		:selected-records="selectedRecords"
		:project-id="projectId"
		:service-id="serviceId"
		group-endpoint="FormShareGroup"
		v-on:closeModal="isGroupShareModalVisible = false">
	</share-group-modal>

	<send-document-modal
		:visible="isSingleShareModalVisible"
		document-type="Company Form"
		:customer="customer"
		:employees="$store.users"
		:value="singleShareModalKey"
		v-on:closeModal="isSingleShareModalVisible = false"
		v-on:send="emailForm">
	</send-document-modal>

	<company-form-modal
		v-if="openFormModal.form"
		:visible="openFormModal.visible"
		:child-template-id="openFormModal.form.child_template_id"
		:form-id="openFormModal.form.id"
		:is-resubmit="openFormModal.isResubmit"
		:project-id="'job_id' in openFormModal.form ? openFormModal.form.job_id : false"
		:service-id="'service_id' in openFormModal.form ? openFormModal.form.service_id : false"
		v-on:closeModal="openFormModal.visible = false">
	</company-form-modal>


</div>
</template>
<script type="text/javascript">
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"

import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import EquipmentPicker from "@/components/equipment_picker/EquipmentPicker"
import SignatureField from "@/components/SignatureField"
import SendDocumentModal from "@/components/SendDocumentModal"
import ShareGroupModal from "@/components/super_components/ShareGroupModal"
import Pagination from "@/components/Pagination"

import CompanyFormModal from "@/components/company_forms/CompanyFormModal"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

import FormMixins from "@/mixins/FormMixins.js"
import ContactMixins from "@/mixins/ContactMixins.js"

export default {
	name: "FormsTab",
	components: {
		CollapsiblePanel,
		Field,
		TableList,
		ModalDialog,
		EquipmentPicker,
		FormGroup,
		SignatureField,
		SendDocumentModal,
		Pagination,
		ShareGroupModal,
		CompanyFormModal,
		FreemiumLockedAlert
	},
	mixins: [FormMixins,ContactMixins],
	props: [
		"assetId",
		"customerId",     // show the customer with this ID in the send modal
		"projectId",
		"serviceId",
		"equipmentId",
		"employeeId",		// Get forms acknowledged by Employee
		"noFilterPanel",
		"title",
		"subTitle"
	],
	data() {
		return {
			viewMode: "forms",
			sharedFormGroups: [],
			sharedFormGroupsFetched: false,

			// Record table page
			page: 1,
			numPages: 0,
			pageLimit: 12,


			// Filtering panel
			panelVisible: false,
			selectedCategory: null,
			selectedTemplate: null,
			activeOnly: false,
			completedDateFrom: null,
			completedDateTo: null,
			expiryDateFrom: null,
			expiryDateTo: null,
			templates: [],   // list of FormTemplate, fetched each category change


			// if customerId is set, fetched and used in SendModal for single form
			customer: null,


			// Table
			forms: [],
			formsLoading: false,
			bulkSelect: false,
			selectedRecords: [],

			// Deactivate confirmation modal
			deactivateFormModal: {
				visible: false,
				form: null
			},

			// Sharing forms modals (group and single)
			isGroupShareModalVisible: false,
			isSingleShareModalVisible: false,
			singleShareModalKey: 0,					// Update this to refresh modal

			// Viewing/Editing a form
			openFormModal: {
				visible: false,
				form: null,
				isResubmit: false
			}
		}
	},
	watch: {
		projectId() {
			this.fetchData()
		},
		serviceId() {
			this.fetchData()
		},
		assetId() {
			this.fetchData()
		},
		customerId() {
			this.fetchData()
		},
		equipmentId() {
			this.fetchData()
		},
		employeeId() {
			this.fetchData()
		}
	},
	computed: {
		fields() {

			if (this.equipmentId) {

				return [
					{label: "Form No.", key: "formNum", showOnMobile: false},
					{label: "Created At", key: 'createdAt', showOnMobile: false, sortBy:'date'},
					{label: "Completed At", key: 'completedAt', showOnMobile: false, sortBy:'date'},
					{label: "Form Description", key: "formDescription", showOnMobile: false},
					{label: "Project/Service", key: 'jobNum', type: 'link', showOnMobile: false},
					{label: "Participants", key: "participantsList", showOnMobile: false},
					{label: "", key: "mobileDetails", showOnDesktop: false}
				]

			} else if (this.employeeId) {

				return [
					{label: "Form No.", key: "formNum", showOnMobile: false},
					{label: "Form Category / Template", key: "breadcrumb",showOnMobile:false},
					{label: "Project/Service", key: 'jobNum', type: 'link', showOnMobile: false},
					{label: "Equipment",key: "equipmentName",showOnMobile:false},
					{label: "Is Active",key: "isActive",type:"boolean",showOnMobile:false},
					{label: "Expiry",key:'expiryLocal',showOnMobile:false,sortBy:'date'},
					{label: "Created At", key: 'createdAt', showOnMobile: false, sortBy:'date'},
					{label: "Date Signed", key: 'completedAt', showOnMobile: false, sortBy: 'date'},
					{label: "", key: "mobileDetails", showOnDesktop: false}
				]

			} else if (this.projectId || this.serviceId) {

				return [
					{label: "Form No.", key: "formNum", showOnMobile: false},
					{label: "Form Category / Template", key: "breadcrumb",showOnMobile:false},
					{label: "Description",key:'childTemplateDescription',showOnMobile:false},
					{label: "Equipment",key: "equipmentName",showOnMobile:false},
					{label: "Is Active",key: "isActive",type:"boolean",showOnMobile:false},
					{label: "Expiry",key:'expiryLocal',showOnMobile:false,sortBy:'date'},
					{label: "Created At", key: 'createdAt', showOnMobile: false, sortBy:'date'},
					{label: "Completed At",key:'completedAt',showOnMobile:false,sortBy:'data'},
					{label: "Participants",key:"participantsList",showOnMobile:false},
					{label: "",key:"mobileDetails",showOnDesktop: false}
				]

			} else {

				return [
					{label: "Form No.", key: "formNum", showOnMobile: false},
					{label: "Project/Service", key: 'jobNum', type: 'link', showOnMobile: false},
					{label: "Form Category / Template", key: "breadcrumb",showOnMobile:false},
					{label: "Description",key:'childTemplateDescription',showOnMobile:false},
					{label: "Equipment",key: "equipmentName",showOnMobile:false},
					{label: "Is Active",key: "isActive",type:"boolean",showOnMobile:false},
					{label: "Expiry",key:'expiryLocal',showOnMobile:false,sortBy:'date'},
					{label: "Created At", key: 'createdAt', showOnMobile: false, sortBy:'date'},
					{label: "Completed At",key:'completedAt',showOnMobile:false,sortBy:'data'},
					{label: "Participants",key:"participantsList",showOnMobile:false},
					{label: "",key:"mobileDetails",showOnDesktop: false}
				]

			}

		},

		categoryOptions() {
			return this.optionify(this.$store.companyFormTemplateCategories,"name")
		},
		templateOptions() {
			return this.optionify(this.templates,"title")
		},
		sharedGroupOtherButtons() {
			return [
				{
					click: "goToPortal",
					text: 'View',
					icon: 'fa-eye',
					title: 'View forms in portal',
					class: 'btn-light'
				},
				{
					click: "copyLinkToClipboard",
					text: 'Copy Link',
					icon: 'fa-copy',
					title: 'Copy portal link to clipboard',
					class: 'btn-light'
				}
			]
		},
		mutatedShareGroups() {
			let vm = this

			return this.sharedFormGroups.map(group => {
				group.sharedBy = group.User.first_name+" "+group.User.last_name
				group.numForms = group.CompanyForm.length
				return group
			})
		},
		mutatedForms() {
			let vm = this

			return this.forms.map(form => {

				let templateCategory = vm.$store.companyFormTemplateCategories.find(cat => form.FormChildTemplate && "FormTemplate" in form.FormChildTemplate && cat.id == form.FormChildTemplate.FormTemplate.category_id)
				
				form.FormChildTemplate.FormTemplate.FormTemplateCategory = templateCategory

				let templateCategoryName = ""
				if (templateCategory && 'name' in templateCategory)
					templateCategoryName = templateCategory.name

				form.childTemplateDescription = form.FormChildTemplate.description
				form.breadcrumb = templateCategoryName + " / " + form.FormChildTemplate.FormTemplate.title
				form.formDescription = form.FormChildTemplate.FormTemplate.title + " / " + form.FormChildTemplate.description

				form.formNum = ""
				if ('form_num' in form && form.form_num) {

					let formNum = form.form_num.toString()
					while (formNum.length < this.formNumLength)  // pad with 0's
						formNum = "0" + formNum

					form.formNum = "#" + formNum
				}

				form.name = form.formNum + " - " + form.FormChildTemplate.description 	// This is for the ShareGroupModal

				form.equipmentName = ""
				if ("Equipment" in form && form.Equipment)
					form.equipmentName = form.Equipment.description

				form.jobNum = {text:"", link:""}
				if ("Job" in form && form.Job) {
					form.jobNum = {
						text: "Project #" + form.Job.job_num,
						link: "/project/" + form.Job.slug + "/dashboard"
					}
				}
				else if ("Service" in form && form.Service) {
					form.jobNum = {
						text: "Service #"+form.Service.job_num,
						link: "/service/"+form.Service.slug+"/dashboard"
					}
				}

				form.isActive = false

				if (form.is_deactivated == 0 && (vm.moment.utc(form.expiry).isAfter(vm.moment()) || !form.expiry))
					form.isActive = true

				form.completedAt = vm.formatDateTimeToLocal(form.created_at)
				form.createdAt = vm.formatDateTimeToLocal(form.created_at)

				form.expiryLocal = vm.formatDateTimeToLocal(form.expiry)

				form.participantsList = ""
				if ('CompanyFormAcknowledgement' in form && form.CompanyFormAcknowledgement) {
					let participantsList = form.CompanyFormAcknowledgement.map(part => part.name).join(", ")
					if (participantsList.length > 40)
						form.participantsList = participantsList.substr(0,40)+"..."
					else
						form.participantsList = participantsList

					// Overwrite completed_at if only one form participant
					if (form.CompanyFormAcknowledgement.length) {
						if ('completed_at' in form.CompanyFormAcknowledgement[0] && form.CompanyFormAcknowledgement[0].completed_at)
							form.completedAt = vm.formatDateTimeToLocal(form.CompanyFormAcknowledgement[0].completed_at)
					}
				}


				form.mobileDetails = "<div><h6 class='mb-0'>Template:</h6> "+form.breadcrumb+"</div>"
				form.mobileDetails += "<div><h6 class='mb-0'>Child Template:</h6> "+form.childTemplateDescription+"</div>"

				if ("Equipment" in form && form.Equipment)
					form.mobileDetails += "<div><h6 class='mb-0'>Equipment:</h6> " + form.equipmentName + "</div>"
				else if ("Job" in form && form.Job)
					form.mobileDetails += "<div><h6 class='mb-0'>Project:</h6> " + form.jobNum.text + "</div>"
				else if ("Service" in form && form.Service)
					form.mobileDetails += "<div><h6 class='mb-0'>Service:</h6> " + form.jobNum.text + "</div>"

				form.mobileDetails += "<div><h6 class='mb-0'>Completed:</h6> "+form.completedAt+"</div>"
				form.mobileDetails += "<div><h6 class='mb-0'>Participants:</h6> "+form.participantsList+"</div>"
				form.mobileDetails += "<div><em>"+form.formNum+"</em></div>"

				if (form.isActive)
					form.mobileDetails += "<div><em>Currently Active</em></div>"

				return form
			})
		}
	},
	methods: {
		setViewMode(mode) {
			if (mode == 'sharedForms')
				this.fetchShareGroups()

			this.viewMode = mode
		},
		copyLinkToClipboard(record) {
			this.copyToClipboard(this.apiRoot+"portal/forms/"+record.slug,true)
		},
		goToPortal(record) {
			window.open(this.apiRoot+"portal/forms/"+record.slug,"_blank")
		},
		doCompanyForm() {
			let payload = {}

			if (this.assetId)
				payload.customer_asset_id = this.assetId
			if (this.projectId)
				payload.job_id = this.projectId
			if (this.serviceId)
				payload.service_id = this.serviceId

			this.$bus.$emit("doCompanyForm", payload)
		},
		editForm(form) {
			this.openFormModal.form = form
			this.openFormModal.visible = true
			this.openFormModal.isResubmit = true
		},
		openForm(form) {
			this.openFormModal.form = form
			this.openFormModal.visible = true
			this.openFormModal.isResubmit = false
		},
		emailForm(payload) {
			let vm = this

			payload.form_id = this.selectedRecords[0].id

			this.postData("CompanyForm/send",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Form notice successfully sent!")
					vm.isSingleShareModalVisible = false
				}
			})
		},
		toggleBulkSelect() {
			this.bulkSelect = !this.bulkSelect
		},
		pageChange(page) {
			this.page = page
			this.fetchForms()
		},
		loadMore() {
			this.page++
			this.fetchForms(true)
		},
		catChange(cat_id) {
			this.fetchTemplates({cat_id})
		},
		completedDateFromChange(value) {
			if (this.moment(value).isAfter(this.moment(this.completedDateTo)))
				this.completedDateTo = this.moment(value).add(1,"day").format("YYYY-MM-DD")

			this.filterControlChange()
		},
		completedDateToChange(value) {
			if (this.moment(value).isBefore(this.moment(this.completedDateFrom)))
				this.completedDateFrom = this.moment(value).subtract(1,"day").format("YYYY-MM-DD")

			this.filterControlChange()
		},
		expiryDateFromChange(value) {
			if (this.moment(value).isAfter(this.moment(this.expiryDateTo)))
				this.expiryDateTo = this.moment(value).add(1,"day").format("YYYY-MM-DD")

			this.filterControlChange()
		},
		expiryDateToChange(value) {
			if (this.moment(value).isBefore(this.moment(this.expiryDateFrom)))
				this.expiryDateFrom = this.moment(value).subtract(1,"day").format("YYYY-MM-DD")

			this.filterControlChange()
		},
		filterControlChange() {
			let vm = this

			this.$nextTick(() => {
				vm.fetchForms()
				vm.page = 1
			})
		},
		openFilterPanel() {
			this.panelVisible = true

			if (this.$store.users.length == 0)
				this.fetchUsers()
		},
		selectedRecordsChange(records) {
			// Remove duplicate forms if they exist
			this.selectedRecords = records.filter((val, index, self) => {
				return self.findIndex(rec => rec.slug == val.slug) === index
			})
		},
		deactivateForm(form) {
			this.deactivateFormModal.visible = true
			this.deactivateFormModal.form = form
		},
		confirmDeactivateForm() {
			let vm = this

			let payload = {
				id: this.deactivateFormModal.form.id,
				is_deactivated: 1
			}

			this.postData("CompanyForm/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSuccess('Form deactivated')
					vm.fetchForms()
					vm.deactivateFormModal.visible = false
				}
			})
		},
		deleteForm(form) {
			let vm = this, deletePromise
			if (this.employeeId) {
				deletePromise = this.postData("CompanyFormAcknowledgement/delete",{id:form.CompanyFormAcknowledgement[0].id})
			}
			else {
				deletePromise = this.postData("CompanyForm/delete",{id: form.id})
			}

			deletePromise.then(response => {
				vm.fetchForms()
			})
		},
		sendForm(form) {
			this.selectedRecords = [form]
			this.openShareModal()
		},
		openShareModal() {
			// Multiple selected? Open group share modal
			if (this.selectedRecords.length > 1) {
				this.isGroupShareModalVisible = true
			}

			// Only one selected? Fetch customer and open DocumentSender
			else {

				let vm = this

				this.isSingleShareModalVisible = true
				this.singleShareModalKey += 1

				if ('Job' in this.selectedRecords[0] && this.selectedRecords[0].Job)
					this.customer = this.selectedRecords[0].Job.Customer
				else if ('Service' in this.selectedRecords[0] && this.selectedRecords[0].Service)
					this.customer = this.selectedRecords[0].Service.Customer

				if (!this.customer) 
					this.fetchCustomer()
			}
		},
		fetchCustomer() {
			let vm = this

			return new Promise((resolve,reject) => {

				if (vm.customerId > 0) {
					vm.getJSON("Contact/find/"+vm.customerId,{include: ["Contact"]}).then(response => {
						if (response.success)
							vm.customer = response.data

						resolve(response)
					})
				}
				else
					resolve({success:false})
			})
		},
		fetchShareGroups() {
			let vm = this

			let jobKey 

			this.sharedFileGroupsFetched = true

			let params = {
				include: [
					{
						model: "User",
						fields: ["id","slug","first_name","last_name"]
					},
					{
						model: "CompanyForm",
						fields: ["service_id","job_id"]
					}
				]
			}

			if (this.serviceId)
				params.filters = [["CompanyForm.service_id",this.serviceId]]
			else if (this.projectId)
				params.filters = [["CompanyForm.job_id",this.projectId]]

			this.spinner(true)
			this.getJSON("FormShareGroup/get",params).then(response => {
				vm.spinner(false)
				if (response.success) 
					vm.sharedFormGroups = response.data
			})
		},
		fetchForms(addToSet) {
			let vm = this

			let msg = false

			vm.spinner(true)
			vm.formsLoading = true

			return new Promise((resolve,reject) => {

				let filters = []
				let include = [
					{
						model: "FormChildTemplate",
						fields:["id","slug","form_template_id","description"],
						include: [
							{
								model: "FormTemplate",
								fields: ["id","slug","category_id","has_equipment","expiry_interval","title"]
							}
						]
					},
					{
						model: 'Job',
						fields: ['job_num'],
					},
					{
						model: 'Service',
						fields: ['job_num'],
					},
				]

				// Set includes for props
				if (vm.serviceId)
					filters.push(["service_id",vm.serviceId])

				else if (vm.projectId)
					filters.push(["job_id",vm.projectId])

				else if (vm.assetId)
					filters.push(["customer_asset_id",vm.assetId])

				else if (vm.equipmentId)
					filters.push(["equipment_id",vm.equipmentId])


				// Set filters for props
				if (!vm.equipmentId)
					include.push("Equipment")

				if (this.employeeId) {

					// Panel filters must be CompanyForm.* on the acknowledgement query
					// (nested include filters are ignored for belongsTo relations)
					let filters = [
						['user_id', this.employeeId],
						['CompanyForm', true]
					]

					if (vm.selectedTemplate)
						filters.push(['CompanyForm.form_template_id', vm.selectedTemplate])

					if (vm.completedDateFrom)
						filters.push(['CompanyForm.created_at >=', vm.completedDateFrom])

					if (vm.completedDateTo)
						filters.push(['CompanyForm.created_at <=', vm.completedDateTo])

					if (vm.expiryDateFrom)
						filters.push(['CompanyForm.expiry >=', vm.expiryDateFrom])

					if (vm.expiryDateTo)
						filters.push(['CompanyForm.expiry <=', vm.expiryDateTo])

					if (vm.activeOnly)
						filters.push(['CompanyForm.is_deactivated', 0])

					let params = {
						fields: ["id","slug","tenant_id","name","email","user_id","phone","company_name","completed_at","is_invite","form_id"],
						filters,
						include: [
							{
								model: "CompanyForm",
								include,
								orders: [
									["created_at","DESC"]
								]
							}
						],
						page: this.page,
						custom_page_limit: this.pageLimit
					}

					vm.getJSON("CompanyFormAcknowledgement/get",params).then(response => {

						vm.formsLoading = false

						if (response.success) {

							if (!addToSet)
								vm.forms = []

							response.data.forEach(ack => {
								if ('CompanyForm' in ack && ack.CompanyForm) {

									// for employeeId, we are only concerned with one participant - the employee
									// Therefore we do not include "CompanyFormAcknowledgement" in the fetch
									// Doing so leads to much larger request times (from 10 seconds to 50+)
									let form = ack.CompanyForm
									delete ack.CompanyForm
									form.CompanyFormAcknowledgement = [ack]

									// Child-model filters cannot OR; trim expired forms here
									if (vm.activeOnly) {
										let isActive = form.is_deactivated == 0 && (vm.moment.utc(form.expiry).isAfter(vm.moment()) || !form.expiry)
										if (!isActive)
											return
									}

									if (!vm.forms.find(f => f.id === form.id))
										vm.forms.push(form)
								}
							})

							vm.numPages = response.meta.num_pages
							vm.bulkSelect = false
							vm.selectedRecords = []
						}

						vm.spinner(false)
						resolve(response)
					})

				}

				else {

					// Set filters for filtering panel
					if (vm.selectedTemplate)
						filters.push(["form_template_id", vm.selectedTemplate])

					if (vm.completedDateFrom)
						filters.push(["created_at >=",vm.completedDateFrom])

					if (vm.completedDateTo)
						filters.push(["created_at <=",vm.completedDateTo])

					if (vm.expiryDateFrom)
						filters.push(["expiry >=",vm.expiryDateFrom])

					if (vm.expiryDateTo)
						filters.push(["expiry <=",vm.expiryDateTo])

					if (vm.activeOnly) {
						filters.push(["is_deactivated",0])

						filters = [
							["expiry >",vm.moment.utc().format("YYYY-MM-DD HH:mm:ss")],
							...filters,
							["expiry",null,"or"],
							...filters
						]
					}

					// Fetch the acknowledgement
					include.push({
						model: "CompanyFormAcknowledgement",
						fields: ["id","slug","tenant_id","name","email","user_id","phone","company_name","completed_at","is_invite"]
					})

					let params = {
						include,
						filters,
						page: this.page,
						custom_page_limit: this.pageLimit,
						orders: [
							["created_at","DESC"]
						]
					}

					vm.getJSON("CompanyForm/get",params).then(response => {

						vm.formsLoading = false

						if (response.success) {

							if (addToSet) {
								vm.forms = [
									...vm.forms,
									...response.data
								]
							}
							else
								vm.forms = response.data

							vm.numPages = response.meta.num_pages
							vm.bulkSelect = false
							vm.selectedRecords = []
						}

						vm.spinner(false)
						resolve(response)
					})
				}

			})

		},
		fetchData() {
			let vm = this

			let promises = [
				this.fetchForms(false),
				this.fetchTemplateCategories(false)
			]

			this.spinner(true)

			Promise.all(promises).then(response => {
				vm.spinner(false)
			})
		}
	},
	created() {
		//if (this.serviceId || this.projectId || this.assetId || this.equipmentId || this.employeeId)
		this.fetchData()

		this.$bus.$on("companyFormParticipantsSaved", () => this.fetchForms(false))
	}
}
</script>

<style type="text/css" scoped>


</style>